let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aJ6RR")).then(() => parcelRequire('d0ucg'));